import { createFileRoute } from '@tanstack/react-router'

import { MEDIA } from '@brickup/shared/locales/de/media'
import { MediaLibrary } from '@/components/Internal/Media/MediaLibrary'
import { PageLayout } from '@/components/Internal/PageLayout'

export const Route = createFileRoute('/internal/media')({
  component: () => (
    <PageLayout title={MEDIA.title}>
      <MediaLibrary />
    </PageLayout>
  ),
})
